<template>
  <div class="exhibition-item box-item" @click="toUrl(`/exhibition/detail?id=${itemData.id}`)">
    <div class="img-wrap">
      <el-image fit="cover" class="img" :src="itemData.img"></el-image>
    </div>
    <div class="title">{{itemData.title}}</div>
    <div class="desc z-flex z-flex-end">时间:{{itemData.date}}</div>
  </div>
</template>

<script>
export default {
  name: "exhibitionItem",
  props: {
    itemData: {
      type:Object,
      default:()=>{},
    }
  },
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
